import { Component, Input, OnInit } from '@angular/core';
import { Transition } from '@uirouter/core';
import { ModalService } from 'src/app/modals/modal.service';
import { ObservationSummaryDTO } from 'src/app/model/observation/observation-summary-dto.model';
import { UserSummaryPermissions } from 'src/app/model/observation/user-summary-permisions.model';

@Component({
    selector: 'observation-nudge',
    templateUrl: './observation-nudge.component.html',
    styleUrls: ['./observation-nudge.component.scss']
})
export class ObservationNudgeComponent implements OnInit {
    @Input() observationSummary?: ObservationSummaryDTO;
    @Input() userSummaryPermissions?: UserSummaryPermissions;
    @Input() targetUserId?: string;

    constructor(private modalService: ModalService,
        public transition: Transition) { }

    ngOnInit(): void {
    }

    get userId() {
        return this.targetUserId ?? this.transition.params<{ userId?: string }>().userId ?? '';
    }

    canNudge(): boolean {
        return this.observationSummary?.permissions.canNudge ?? false;
    }

    nudge() {
        if (this.observationSummary) {
            this.modalService.openSendObservationNudge(
                this.observationSummary?.waitingOnId ?? this.userId,
                this.observationSummary.observationId,
                this.observationSummary.itemType,
                this.userId
            );
        }
    }


}
